import React from 'react';
import {
  Box,
  CircularProgress,
  Typography,
  Backdrop
} from '@mui/material';

const LoadingSpinner = ({ message = 'Loading...', fullScreen = false }) => {
  if (fullScreen) {
    return (
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <Box display="flex" flexDirection="column" alignItems="center">
          <CircularProgress color="inherit" />
          <Typography variant="h6" sx={{ mt: 2 }}>
            {message}
          </Typography>
        </Box>
      </Backdrop>
    );
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center" p={3}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <CircularProgress />
        <Typography variant="body2" sx={{ mt: 1 }}>
          {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default LoadingSpinner;
